/** Публичный URL сайта (каноникал, Open Graph). Переопределение: REACT_APP_SITE_URL */
const raw =
  (typeof process !== "undefined" && process.env.REACT_APP_SITE_URL) ||
  "https://bay-sport.ru";

export const SITE_ORIGIN = String(raw).replace(/\/$/, "");

export const SITE_NAME = "Бай.Код";

export const DEFAULT_DESCRIPTION =
  "Бай.Код — IT-маркетплейс для продажи и поиска IT-решений, программ и приложений. Безопасные сделки между разработчиками и покупателями. Bay.Code, Байкод.";
